import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'resize-observer-polyfill/dist/ResizeObserver.global' // React Native for Webの警告対策
import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import AppLoading from './AppLoading'
import KokosilClientInterface from './kokosil-client-interface'
import KokosilClientError from './KokosilClientError'
import {
  initializeAnalytics, sendAnalyticsPageview, sendAnalyticsEvent
} from './google-analytics'
import './vector-icons-stylesheet'
import * as serviceWorker from './serviceWorker'

// Googleアナリティクス
if (window.location.hostname === 'katsushika-data.kokosil.net') {
  initializeAnalytics('UA-83695758-1')
  sendAnalyticsPageview()
}
window.addEventListener('hashchange', () => {
  sendAnalyticsEvent('chatbot', 'route', window.location.hash)
}, false)

// window.KokosilClientInterfaceを待つ
const root = document.getElementById('root')
ReactDOM.render(<AppLoading />, root)
const resolved = (available) => {
  ReactDOM.render(<App />, root)
}
const rejected = () => {
  sendAnalyticsEvent('chatbot', 'kci:error')
  ReactDOM.render(<KokosilClientError />, root)
}
KokosilClientInterface
  .wait()
  .then(resolved, rejected)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
